module.exports = __webpack_public_path__ + "static/img/yqxImg.7ac692fa.png";